<template>
  <!-- <div class="locale-changer" style="float: right; margin-right: 10px"> -->
    <li>
      <span class="dropdown" @click="changeLang('en')"
        ><img src="../assets/img/en_lang.png" style="width: 25px" /> EN</span
      >
    </li>
    <li>
      <span class="dropdown" @click="changeLang('es')"
        ><img src="../assets/img/es_lang.png" style="width: 25px" /> ES</span
      >
    </li>
    <li>
      <span class="dropdown" @click="changeLang('fr')"
        ><img src="../assets/img/fr_lang.png" style="width: 25px" /> FR</span
      >
    </li>
    <li>
      <span class="dropdown" @click="changeLang('ge')"
        ><img src="../assets/img/ge_lang.png" style="width: 25px" /> GE</span
      >
    </li>
    <li>
      <span class="dropdown" @click="changeLang('va')"
        ><img src="../assets/img/va_lang.png" style="width: 25px" /> VA</span
      >
    </li>
    <li>
      <span class="dropdown" @click="changeLang('ca')"
        ><img src="../assets/img/ca_lang.png" style="width: 25px" /> CA</span
      >
    </li>

    <!-- <span @click="changeLang('es')"
      ><img src="../assets/img/es_lang.png" style="width: 25px"
    /></span>
    <span @click="changeLang('en')"
      ><img src="../assets/img/en_lang.png" style="width: 25px"
    /></span> -->
  <!-- </div> -->
</template>

<script>
import { VueCookieNext } from "vue-cookie-next";

export default {
  name: "locale-changer",
  data() {
    return {
      langs: [{ language: "EN" }, { language: "ES" }, { language: "FR" }, { language: "GE" }, { language: "VA" }, { language: "CA" }],
    };
  },
  mounted: function () {
    if (!VueCookieNext.getCookie("lang")) {
      this.changeLang('es');
    }
    this.$i18n.locale = VueCookieNext.getCookie("lang");
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang;
      VueCookieNext.setCookie("lang", lang, { expire: Infinity });
    },
  },
};
</script>

<style scoped>
.dropdown {
  font-weight: bold;
  padding: 10pt;
  font-size: 10pt;
}
li {
  cursor: pointer;
}
</style>
